import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const sections = [
  { id: 'agreement', label: 'Agreement to these terms' },
  { id: 'platform', label: 'What Clawappz provides' },
  { id: 'businesses-customers', label: 'Businesses and customers' },
  { id: 'accounts', label: 'Accounts and access' },
  { id: 'bookings-orders-requests', label: 'Bookings, orders, and requests' },
  { id: 'payments', label: 'Payments, fees, and refunds' },
  { id: 'acceptable-use', label: 'Acceptable use' },
  { id: 'content', label: 'Content and intellectual property' },
  { id: 'availability', label: 'Service availability' },
  { id: 'termination', label: 'Suspension and termination' },
  { id: 'liability', label: 'Liability' },
  { id: 'changes', label: 'Changes and contact' },
];

const TermsOfService = () => (
  <LegalPageLayout
    title="Terms of Service"
    description="These terms explain the rules for using Clawappz and the responsibilities of businesses and customers using the platform."
    sections={sections}
  >
    <section>
      <h2>1. Agreement to these terms</h2>
      <p>By accessing or using Clawappz, you agree to these Terms of Service. If you use Clawappz for a business or organisation, you confirm that you have authority to accept these terms for it. If you do not agree, do not use the platform.</p>
    </section>
    <section>
      <h2>2. What Clawappz provides</h2>
      <p>Clawappz provides tools that help independent businesses present services and products, receive bookings and orders, manage custom requests, coordinate staff workflows, communicate status updates, and record or process payments. Features may vary by business, subscription, location, or account permissions.</p>
    </section>
    <section>
      <h2>3. Businesses and customers</h2>
      <p>Businesses using Clawappz are responsible for the services and products they advertise and provide, including descriptions, availability, pricing, fulfilment, licences, customer service, cancellations, and refunds. Clawappz supplies the platform but is not the provider of those businesses’ services or products.</p>
    </section>
    <section>
      <h2>4. Accounts and access</h2>
      <ul>
        <li>Provide accurate account information and keep it current.</li>
        <li>Safeguard your credentials and take responsibility for activity through your account.</li>
        <li>Administrators are responsible for staff invitations, roles, assignments, and company access.</li>
        <li>Notify us promptly if you suspect unauthorised access or misuse.</li>
      </ul>
    </section>
    <section>
      <h2>5. Bookings, orders, and requests</h2>
      <p>Submitting a booking, order, or request creates a record with the relevant business. A custom request is not necessarily accepted or scheduled until the business confirms or completes its review. Availability can change, and a business may reject or cancel a submission where permitted. Customers should check their details before submission and retain their reference code for tracking.</p>
    </section>
    <section>
      <h2>6. Payments, fees, and refunds</h2>
      <p>Some businesses require full or partial payment before a booking, order, or request can proceed. Online payments are processed through the provider presented during checkout. Applicable processing or platform fees will be shown before payment. Refunds, cancellations, disputes, and fulfilment issues are subject to applicable law and the relevant business’s disclosed policy, except where Clawappz is directly responsible for the charge.</p>
    </section>
    <section>
      <h2>7. Acceptable use</h2>
      <p>You must not use Clawappz to:</p>
      <ul>
        <li>break the law, infringe another person’s rights, or facilitate fraud;</li>
        <li>submit false, deceptive, abusive, harmful, or unlawful content;</li>
        <li>probe, disrupt, overload, bypass, or attempt unauthorised access to the platform;</li>
        <li>introduce malicious code, scrape protected information, or misuse another account; or</li>
        <li>harm Clawappz, a participating business, or another user.</li>
      </ul>
    </section>
    <section>
      <h2>8. Content and intellectual property</h2>
      <p>Clawappz and its platform materials are protected by applicable intellectual-property laws. Businesses remain responsible for names, descriptions, logos, images, and other content they upload. Uploading content grants Clawappz permission to host, process, reproduce, and display it as needed to operate the platform and the uploader’s storefront.</p>
    </section>
    <section>
      <h2>9. Service availability</h2>
      <p>We work to keep Clawappz secure and available, but uninterrupted or error-free operation is not guaranteed. Maintenance, third-party services, internet conditions, security events, or circumstances outside our reasonable control may affect access. Features may be updated, replaced, or discontinued where reasonably necessary.</p>
    </section>
    <section>
      <h2>10. Suspension and termination</h2>
      <p>We may restrict or suspend access when reasonably necessary to protect users, comply with law, address non-payment, investigate misuse, or enforce these terms. You may stop using Clawappz at any time. Provisions that should continue by their nature will remain effective after termination.</p>
    </section>
    <section>
      <h2>11. Liability</h2>
      <p>To the extent permitted by applicable law, Clawappz is not responsible for indirect or consequential loss, or for the independent acts, omissions, products, services, or policies of businesses using the platform. Nothing in these terms excludes rights or liabilities that cannot lawfully be excluded.</p>
    </section>
    <section>
      <h2>12. Changes and contact</h2>
      <p>We may update these terms to reflect changes to the platform, law, or our operations. The updated date will appear at the top of this page. Questions can be sent to <a href="mailto:support@clawappz.com" className="font-medium text-primary hover:underline">support@clawappz.com</a>.</p>
    </section>
  </LegalPageLayout>
);

export default TermsOfService;
